import { useEffect } from "react";

import {
  Globe,
  HamiltonianOperator,
  Particle,
  Hyperwebster,
  Alphabet,
  Time,
} from "../components";

import { jigglyGoos, units } from "../utilities/Functions";

import { OrbitControls } from "@react-three/drei";

// CRUD Functions

// react useEffect hook wrapper for periodic database queries
export function useDatabase(fn, ms = 0) {
  useEffect(() => {
    fn(); // fire instantly
    if (ms > -1) {
      const id = setInterval(() => fn(), ms | 6000); // fire after x ms in loop
      return () => clearInterval(id);
    }
  }, []);
}

// database url e.g. 10.42.0.1:8080
export const db =
  "http://" + process.env.REACT_APP_DATABASE_IP_AND_PORT + "/api/";

// authantication function that interfaces with  db + auth/login
export function auth(obj = {}) {
  return new Promise(
    async (response, error) =>
      // native js fetch function
      await fetch(db + "auth/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(obj),
      })
        // if response ok get data from response else pipe everything to error
        .then(async (r) => (r.ok ? response((await r.json()).data) : error(r)))
        .catch((e) => error(e))
  );
}

// POST request wrapper
//export function push(ref = "", obj = {}, authNeeded = true) {
//  return new Promise(async (response, error) => {
//    // do you even need auth? depends on database api implementation.
//    if (authNeeded)
//      if (Cookies.get("token"))
//        // check for existence of auth token
//        await fetch(db + ref, {
//          method: "POST",
//          headers: {
//            "Content-Type": "application/json",
//            Authorization: "Bearer " + Cookies.get("token"), // pass auth token in header
//          },
//          body: JSON.stringify(obj),
//        })
//          .then(async (r) =>
//            r.ok ? response((await r.json()).data) : error(r)
//          )
//          .catch((e) => error(e));
//      else
//        error(
//          "Couldn't find token in cookies! log in to get an auth token or set authNeeded to false in code."
//        );
//    else
//      await fetch(db + ref, {
//        method: "POST",
//        headers: {
//          "Content-Type": "application/json",
//        },
//        body: JSON.stringify(obj),
//      })
//        .then(async (r) => (r.ok ? response((await r.json()).data) : error(r)))
//        .catch((e) => error(e));
//  });
//}
//
//// SET request wrapper
//export function set(ref = "", obj = {}, authNeeded = true) {
//  return new Promise(async (response, error) => {
//    if (authNeeded)
//      if (Cookies.get("token"))
//        await fetch(db + ref, {
//          method: "PUT",
//          headers: {
//            "Content-Type": "application/json",
//            Authorization: "Bearer " + Cookies.get("token"),
//          },
//          body: JSON.stringify(obj),
//        })
//          .then(async (r) =>
//            r.ok ? response((await r.json()).data) : error(r)
//          )
//          .catch((e) => error(e));
//      else
//        error(
//          "Couldn't find token in cookies! log in to get an auth token or set authNeeded to false in code."
//        );
//    else
//      await fetch(db + ref, {
//        method: "PUT",
//        headers: {
//          "Content-Type": "application/json",
//        },
//        body: JSON.stringify(obj),
//      })
//        .then(async (r) => (r.ok ? response((await r.json()).data) : error(r)))
//        .catch((e) => error(e));
//  });
//}
//
//// GET request wrapper
//export function get(ref = "", authNeeded = true) {
//  return new Promise(async (response, error) => {
//    if (authNeeded)
//      if (Cookies.get("token"))
//        fetch(db + ref, {
//          method: "GET",
//          headers: {
//            "Content-Type": "application/json",
//            Authorization: "Bearer " + Cookies.get("token"),
//          },
//        })
//          .then(async (r) =>
//            r.ok ? response((await r.json()).data) : error(r)
//          )
//          .catch((e) => error(e));
//      else
//        error(
//          "Couldn't find token in cookies! log in to get an auth token or set authNeeded to false in code.."
//        );
//    else
//      fetch(db + ref, {
//        method: "GET",
//        headers: {
//          "Content-Type": "application/json",
//        },
//      })
//        .then(async (r) => (r.ok ? response((await r.json()).data) : error(r)))
//        .catch((e) => error(e));
//  });
//}
//
//// DELETE request wrapper
//export function remove(ref = "", authNeeded = true) {
//  return new Promise(async (response, error) => {
//    if (authNeeded)
//      if (Cookies.get("token"))
//        fetch(db + ref, {
//          method: "DELETE",
//          headers: {
//            "Content-Type": "application/json",
//            Authorization: "Bearer " + Cookies.get("token"),
//          },
//        })
//          .then(async (r) =>
//            r.ok ? response((await r.json()).data) : error(r)
//          )
//          .catch((e) => error(e));
//      else
//        error(
//          "Couldn't find token in cookies! log in to get an auth token or set authNeeded to false in code."
//        );
//    else
//      fetch(db + ref, {
//        method: "DELETE",
//        headers: { "Content-Type": "application/json" },
//      })
//        .then(async (r) => (r.ok ? response((await r.json()).data) : error(r)))
//        .catch((e) => error(e));
//  });
//}
export function cardsData() {
  return [
    {
      title: "toothbrush",
      communities: ["a", "b", "c", "d"],
      energy: "10",
      object: { path: "objects/tooth-brush.obj" },
      scale: 0.4,
    },
    {
      title: "generative linear transformer",
      communities: ["openAI"],
      scale: 0.4,
    },
    {
      title: "generative non-linear transformer",
      scale: 0.4,
    },
  ];
}

export function stemCardsData() {
  return [
    {
      title: "compounds pokedex",
      communities: ["chemistry"],
    },
    {
      title: "elements",
      communities: ["stars"],
      element: (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "auto auto auto auto auto",
          }}
        >
          {jigglyGoos().map((v, i) => (
            <div key={i}>{v.name}</div>
          ))}
        </div>
      ),
    },
    {
      title: "units",
      communities: ["physics"],
      element: units.map((v, i) => <div key={i}>{v[0] + " " + v[1]}</div>),
    },
    {
      title: "dictionary",
      communities: ["linguistics"],
      element: (
        <Hyperwebster>
          <Alphabet />
        </Hyperwebster>
      ),
    },
    {
      title: "syntax",
      communities: ["linguistics"],
      element: <div></div>,
    },
    {
      title: "semantic",
      communities: ["linguistics"],
      element: <div></div>,
    },
    {
      title: "phonetic",
      communities: ["linguistics"],
      element: <div></div>,
    },

    {
      title: "alphabet",
      communities: ["linguistics"],
      element: <Alphabet />,
    },
    {
      title: "character",
      communities: ["linguistics"],
      element: <div>monkey stick scratch</div>,
    },
    {
      title: "expression",
      communities: ["mathematics"],
      element: (
        <>
          <div>linear</div>
          <div>non-linear</div>
        </>
      ),
    },
    {
      title: "atom",
      communities: ["physics"],
      object: {
        cameraDistance: 20,
        mesh: (
          <>
            <OrbitControls />
            <HamiltonianOperator resolution={20} extent={2}>
              <Particle />
            </HamiltonianOperator>
          </>
        ),
      },
      scale: 4,
    },

    {
      title: "electron",
      communities: ["physics"],
      object: {
        cameraDistance: 20,
        mesh: <Globe />,
      },
    },
    {
      title: "photon",
      communities: ["physics"],
      object: {
        cameraDistance: 20,
        mesh: <Globe />,
      },
    },
    {
      title: "energy",
      communities: ["sun", "SPARC"],
      energy: "4600000000000000",
      object: { mesh: <Globe /> },
    },
    {
      title: "time",
      communities: ["physics"],
      element: <Time />,
    },
  ];
}
